import OrbitTool from "./new-orbit-tool";
import Tool from "./tool";
import { Mesh, PerspectiveCamera, Raycaster, Scene, Vector2 } from "three";
import { ndc } from "../view3d/coordinates";
import Signal from "../control-flow/signal";
import { RoulerPromise } from "../animation/rouler";
import { easeInOutSine } from "../animation/easing";
import { animatePose } from "../animation/animate-pose";

/**
 * Number of milliseconds for the duration of the animation. This corresponds
 * to five frames at 30fps.
 */
const DURATION = 167;

/**
 * This is a temporary variable we use for setting up the transition animation.
 * It doesn't really matter that this is a pespective camera, the tool should
 * work with orthographic cameras as well.
 */
const targetCamera = new PerspectiveCamera();


export class OrbitRetargetTool extends Tool {

    orbit: OrbitTool;
    scene: Scene;

    onChange: Signal = new Signal('onChange', 'tools');

    mouse: Vector2 = new Vector2();
    raycaster = new Raycaster();

    transition?: RoulerPromise = null;

    constructor(orbit: OrbitTool, scene: Scene) {
        super();
        this.orbit = orbit;
        this.scene = scene;
    }

    enable(): void {
        this.orbit.canvas.removeEventListener('dblclick', this.begin);
        this.orbit.canvas.addEventListener('dblclick', this.begin);
    }

    disable(): void {
        this.orbit.canvas.removeEventListener('dblclick', this.begin);
    }

    begin(event: MouseEvent): void {
        const
            target = event.target as HTMLCanvasElement,
            // convert clientX and Y from CSS pixels to canvas pixels
            x = event.offsetX * (target.width / target.clientWidth),
            y = event.offsetY * (target.height / target.clientHeight),
            meshes: Mesh[] = [];

        this.scene.traverseVisible((obj: any) => { if(obj.isMesh) meshes.push(obj); });


        // Convert x and y to normalized device coordinates and place the
        // result into our mouse vector
        ndc(x, y, target.width, target.height, this.mouse);
        this.raycaster.setFromCamera(this.mouse, this.orbit.camera);

        const intersections = this.raycaster.intersectObjects(meshes, true); 

        if(intersections.length > 0) {
            const top = intersections[0];
            this.orbit.target.copy(top.point);
            targetCamera.position.copy(this.orbit.camera.position);
            targetCamera.quaternion.copy(this.orbit.camera.quaternion);
            targetCamera.lookAt(this.orbit.target);

            if(this.transition) this.transition.canceled = true;
            this.transition = animatePose(
                DURATION, this.orbit.camera, targetCamera,
                (t: number) => {
                    this.onChange.trigger();
                    return easeInOutSine(t);
                });
            this.transition.catch(() => {});
        }
    }

    cancel(): void {
        // never called
    }

    end(): void {
        // never called
    }

}

export default OrbitRetargetTool;
